export const peripheryAddresses = {
  adaptiveCurveIRMFactory: "0xae752d786ecAf6683f61b7D910F221edD003895b",
  capRiskStewardFactory: "0xD3A2b711239fC7e1c14266e71000b7360Ac9C58C",
  edgeFactory: "0x4B930F0222349c2092b8531A42295262cc4F0e4A",
  edgeFactoryPerspective: "0x6ECaCa741ec5013fc709292443b5F43A93a1deCe",
  escrowedCollateralPerspective: "0x977590fA311755DA2fa1421c1A944520b684f90F",
  eulerEarnFactoryPerspective: "0x6BE13d0bb485289D39536458afEfbB32312a5179",
  eulerEarnGovernedPerspective: "0x08B817C17d84DF89AA371084D910081a5Cc04724",
  eulerEarnPublicAllocator: "0x0dFFc3A53693bCd8e42FAd9be94fB8f1Fb64A8EE",
  eulerUngoverned0xPerspective: "0x24F2b095df7c76266fd037b847360f69eD591549",
  eulerUngovernedNzxPerspective: "0xFff2dA17172588629Adf5BDEF275d9AbEBbA39Bd",
  evkFactoryPerspective: "0xFEA8e8a4d7ab8C517c3790E49E92ED7E1166F651",
  externalVaultRegistry: "0x6A60B3E561F0a7d9587F3210426FeC882224dF2d",
  feeCollector: "0x0000000000000000000000000000000000000000",
  feeFlowController: "0xbF4906E2F20362c3d746F7eFfF54abB8282902ed",
  feeFlowControllerUtil: "0xBb218B381dd403B4F5ED6D60BE0cf4134c35a29f",
  fixedCyclicalBinaryIRMFactory: "0xf44333b5A3EB4D069AB8Bb6FEc88225d8eE5d2bB",
  governedPerspective: "0xafC8545c49DF2c8216305922D9753Bf60bf8c14A",
  governorAccessControlEmergencyFactory:
    "0x424d5C3e0046168C2F193Aa939c7a9aaB01eeB9A",
  irmRegistry: "0x384926132a5E516Bc8f79e6d7cd4301B6a887DfC",
  kinkIRMFactory: "0x2d94C898a17f9D8c0bA75010A51cd61BF55b402E",
  kinkyIRMFactory: "0x9907E7F6637B161c19c08cc716C23f53b49C9Ec2",
  oracleAdapterRegistry: "0x3cD76476bB7933A99Fa5bAa05446e71e07CDe0ca",
  oracleRouterFactory: "0xA9287853987B107969f181Cce5e25e0D09c1c116",
  swapVerifier: "0x30660764A7a05B84608812C8AFC0Cb4845439EEe",
  swapper: "0x0D3d0F97eD816Ca3350D627AD8e57B6AD41774df",
  termsOfUseSigner: "0x0cE811D4171c2ab8bD8BeF5BeCf13Dc40baB0539",
} as const
